import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3 col-sm-6 col-xs-12" }
const _hoisted_4 = { class: "info-box" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-icon bg-aqua" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hand-pointer-o" })
], -1)
const _hoisted_6 = { class: "info-box-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-text" }, "访问量总数（PV）", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = { class: "info-box-number" }
const _hoisted_10 = { class: "col-md-3 col-sm-6 col-xs-12" }
const _hoisted_11 = { class: "info-box" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-icon bg-red" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-desktop" })
], -1)
const _hoisted_13 = { class: "info-box-content" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-text" }, "独立IP总数（IP）", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "info-box-number" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix visible-sm-block" }, null, -1)
const _hoisted_18 = { class: "col-md-3 col-sm-6 col-xs-12" }
const _hoisted_19 = { class: "info-box" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-icon bg-green" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-mobile" })
], -1)
const _hoisted_21 = { class: "info-box-content" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-text" }, "独立访客总数（UV）", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode()
const _hoisted_24 = { class: "info-box-number" }
const _hoisted_25 = { class: "col-md-3 col-sm-6 col-xs-12" }
const _hoisted_26 = { class: "info-box" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-icon bg-yellow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart" })
], -1)
const _hoisted_28 = { class: "info-box-content" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "info-box-text" }, "订单总数", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode()
const _hoisted_31 = { class: "info-box-number" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  class: "col-md-12",
  id: "search_container"
}
const _hoisted_34 = { class: "box box-primary" }
const _hoisted_35 = { class: "box-header with-border" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h3", { class: "box-title" }, "经营分析", -1)
const _hoisted_37 = {
  class: "pull-right",
  width: "40%",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "请选择年月", -1)
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<option value=\"2023\">2023</option><option value=\"2024\">2024</option><option value=\"2025\">2025</option><option value=\"2026\">2026</option><option value=\"2027\">2027</option>", 5)
const _hoisted_44 = [
  _hoisted_39
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "年", -1)
const _hoisted_46 = ["value"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "月", -1)
const _hoisted_48 = { class: "box-body" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-8" }
const _hoisted_51 = { class: "chart" }
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "本月统计")
], -1)
const _hoisted_54 = { class: "progress-group" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, "本月访问量总数", -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode()
const _hoisted_57 = { class: "progress-number" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "progress sm" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-aqua",
    style: {"width":"100%"}
  })
], -1)
const _hoisted_59 = { class: "progress-group" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, "本月独立IP总数", -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode()
const _hoisted_62 = { class: "progress-number" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "progress sm" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-red",
    style: {"width":"100%"}
  })
], -1)
const _hoisted_64 = { class: "progress-group" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, "本月独立访客总数", -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode()
const _hoisted_67 = { class: "progress-number" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "progress sm" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-green",
    style: {"width":"100%"}
  })
], -1)
const _hoisted_69 = { class: "progress-group" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, "本月订单总数", -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode()
const _hoisted_72 = { class: "progress-number" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "progress sm" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-yellow",
    style: {"width":"100%"}
  })
], -1)
const _hoisted_74 = { class: "progress-group" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, "本月订单总金额", -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode()
const _hoisted_77 = { class: "progress-number" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "progress sm" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar progress-bar-primary",
    style: {"width":"100%"}
  })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_echart_view = _resolveComponent("echart-view")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data && _ctx.data[0]['value']), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.data && _ctx.data[1]['value']), 1)
            ])
          ])
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.data && _ctx.data[2]['value']), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.data && _ctx.data[3]['value']), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("select", {
                  name: "year",
                  id: "year_select",
                  style: {"margin":"0 4px"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.year) = $event))
                }, _hoisted_44, 512), [
                  [_vModelSelect, _ctx.year]
                ]),
                _hoisted_45,
                _withDirectives(_createElementVNode("select", {
                  name: "month",
                  id: "month_select",
                  style: {"margin":"0 4px"},
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.month) = $event))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (item) => {
                    return _createElementVNode("option", { value: item }, _toDisplayString(item), 9, _hoisted_46)
                  }), 64))
                ], 512), [
                  [_vModelSelect, _ctx.month]
                ]),
                _hoisted_47
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_echart_view, {
                      option: _ctx.option3,
                      style: {"width":"100%","height":"350px"}
                    }, null, 8, ["option"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _hoisted_56,
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.homeAnalyse.totalMonthBrowseCount||0), 1),
                    _hoisted_58
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _hoisted_61,
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.homeAnalyse.totalMonthIpCount||0), 1),
                    _hoisted_63
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _hoisted_66,
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.homeAnalyse.totalMonthDeviceCount||0), 1),
                    _hoisted_68
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _hoisted_71,
                    _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.homeAnalyse.totalMonthOrderCount||0), 1),
                    _hoisted_73
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _hoisted_76,
                    _createElementVNode("span", _hoisted_77, "￥" + _toDisplayString(_ctx.homeAnalyse.totalMonthOrderMoney||_ctx.totalMonthOrderMoney), 1),
                    _hoisted_78
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}